import { http } from '@pendo/http';
import get from 'lodash/get';
import values from 'lodash/values';

export const PARTNER_TYPES = {
    partner: 'partner',
    silent: 'silentPartner',
    disabled: 'disabled',
};

export const PARTNER_STATUS = {
    partner: 'trainingPartner',
    silent: 'silentTrainingPartner',
    disabled: 'disabled',
};

export const USER_INTERFACE = {
    engage: 'engage',
    adopt: 'adopt',
};

export const ADOPT_PRODUCT_LINES = {
    adopt: 'adopt',
    adoptReseller: 'adoptReseller',
    adoptEndUser: 'adoptEndUser',
};

// The reason we’re adding 1 to all these is to ensure today is included. So the key for 30 day retention is
// 30 and the actual value is 31 because number needs to include today.
export const RECORDING_RETENTION_DAYS = new Map([
    [14, 15],
    [30, 31],
    [90, 91],
]);

export const CLIP_RETENTION_DAYS = {
    default: 366,
    restricted: 31,
};

export const RC_LIMITS = {
    unlimited: -1,
    unlimitedLabel: 'Unlimited',
    limited: 1,
    limitedLabel: 'Limited',
};

export function isNumberOfPublicResourceCentersUnlimited (rcLimit) {
    return rcLimit === RC_LIMITS.unlimited;
}

export function fetchProductLines (subscriptionId = '_SID_') {
    return http.get(`/api/s/${subscriptionId}/productline`).then((res) => res.data);
}
/*
 *   Product line endpoints are case sensitive
 *  /api/s/${subId}/productline/sessionReplay != /api/s/${subId}/productline/sessionReplay
 */

export function fetchProductLineByType (subId = '_SID_', type) {
    return http.get(`/api/s/${subId}/productline/${type}`).then((res) => res.data);
}

export function setFlagForType ({ type, flag, set, subId = '_SID_' }) {
    return http.put(`/api/s/${subId}/productline/${type}/${flag}`, { set }).then((res) => res.data);
}

export function setProductLineMetadata ({ type, data, subId = '_SID_' }) {
    return http.put(`/api/s/${subId}/productline/${type}/metadata`, { ...data }).then((res) => res.data);
}

export function updateProductLineMetadata ({ subscriptionId, productType, productLineMetadata }) {
    return http
        .put(`/api/super/s/${subscriptionId}/productline/${productType}/metadata`, productLineMetadata)
        .then((res) => res.data);
}

export function getFeedbackUnifiedLoginEnabled (productLine) {
    if (!productLine) {
        return false;
    }

    const isFeedbackPlAndLoginEnabled =
        productLine.type === 'feedback' && get(productLine, 'metadata.unifiedLoginEnabled', false);

    return productLine.purchased && (isFeedbackPlAndLoginEnabled || !!productLine.configured);
}

export function isExtensionEnabledForSubscription (subscription) {
    return isMetadataEnabledForAnyProductLine(subscription.productLines, 'extensionApplicationEnabled');
}

export function isMetadataEnabledForAnyProductLine (productLineMap, metadataName) {
    return values(productLineMap).some((productLine) => {
        return get(productLine, `metadata.${metadataName}`, false);
    });
}

export function useAdoptParityCustomRolesEnabled (adoptEndUserPl, adoptPl) {
    return [adoptEndUserPl, adoptPl].some((pl) => get(pl, 'metadata.useAdoptParityCustomRoles', false));
}

/** listenPremium true = paid Listen (no freemium). Missing defaults to true (premium / legacy). */
export function isVocListenFreemiumActiveFromProductLines (productLines = {}) {
    const vocProductLine = productLines.voc;
    if (!get(vocProductLine, 'purchased')) {
        return false;
    }

    return !get(vocProductLine, 'metadata.freemium.listenPremium', true);
}
